/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';

const SprakserviceIcon = (props) => (
  <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_sprakservice_icon)">
      <path d="M45.8097 16.0607C44.7146 16.0607 43.6195 15.1482 43.6195 13.8706V4.19761H34.4941C33.399 4.19761 32.304 3.28506 32.304 2.0075C32.304 0.91244 33.2165 -0.182617 34.4941 -0.182617H47.8173V13.6881C47.9998 14.9657 46.9047 16.0607 45.8097 16.0607Z" fill="#FF595A" />
      <path d="M23.9087 32.8517L14.7832 21.7186C14.0532 20.8061 14.2357 19.5285 15.1482 18.7985C16.0608 18.0684 17.3384 18.2509 18.0684 19.1635L23.7262 26.0989L44.1673 0.730036C44.8973 -0.182512 46.1749 -0.365021 47.0874 0.365017C48 1.09506 48.1825 2.37262 47.4524 3.28517L23.9087 32.8517Z" fill="#FF595A" />
      <path d="M23.9087 48C10.7681 48 0 37.2319 0 23.9087C0 10.5856 10.7681 0 23.9087 0C25.0038 0 26.0989 0.912548 26.0989 2.19011C26.0989 3.46768 25.1863 4.38023 23.9087 4.38023C12.9582 4.38023 4.19772 13.1407 4.19772 24.0913C4.19772 35.0418 12.9582 43.8023 23.9087 43.8023C34.8593 43.8023 43.6198 35.0418 43.6198 24.0913C43.6198 22.9962 44.5323 21.9011 45.8099 21.9011C47.0875 21.9011 48 22.8137 48 24.0913C48 37.2319 37.2319 48 23.9087 48Z" fill="#FF595A" />
    </g>
    <defs>
      <clipPath id="clip0_sprakservice_icon">
        <rect width={48} height={48} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const MemoSprakserviceIcon = React.memo(SprakserviceIcon);
export default MemoSprakserviceIcon;
